import Vue from 'vue'

export default {
  async init() {
    return (await Vue.axios.get('/dashboard/init')).data
  }
}
